import { Modal } from '@praktio/common-ui';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { NavigateFunction, useNavigate } from 'react-router-dom';

interface IProps {
  type: string;
  name: string;
  onHide: () => void;
  show: boolean;
  dispatchAction: (data: any & { navigate: NavigateFunction }) => void;
  dispatchData: { [key: string]: any };
}

const DeleteModal: FC<IProps> = ({ type, name, onHide, show, dispatchAction, dispatchData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Modal
      onHide={onHide}
      onSave={() => {
        dispatch(dispatchAction({ ...dispatchData, navigate }));
      }}
      show={show}
      confirmationString={'DELETE'}
      title={`Delete ${type}`}
      description={`Are you sure you want to delete the ${type.toLowerCase()} "${name}"? This is permanent and data cannot be recovered!`}
    />
  );
};

export default DeleteModal;
